import { Box, Stack } from "@mui/material";
import { Custom, Field, Workflow } from "components";
import { useApp, useTheme } from "contexts";
import { useWorkflow } from "contexts/components";
import { IMenu } from "interfaces";
import { forwardRef, useImperativeHandle } from "react";
import { createStep } from "utils/helpers";

const StepDetails = forwardRef((_, ref) => {
  const { updateData, data } = useWorkflow<Workflow.Utils.PotluckType>(); // Get updateData from context

  const { t } = useApp();
  const { theme } = useTheme();

  useImperativeHandle(ref, () => ({
    validate: () => {
      const isValid = data.potluck.menu.length > 0;

      return {
        isValid,
        message: isValid
          ? ""
          : t.component.workflow.potluck.validation.one_menu_item,
      };
    },
  }));

  return (
    <>
      <Custom.Typography size={theme.font.md} weight={theme.font.bold}>
        {t.component.workflow.potluck.start_potluck}
      </Custom.Typography>

      <Box mt={theme.spacing.md}>
        <Stack spacing={theme.spacing.sm}>
          <Custom.TextField
            required
            label={t.label.party_name}
            placeholder={t.placeholder.party_name}
            fullWidth
            value={data.potluck.party_name}
            onChange={(e) => updateData("potluck.party_name", e.target.value)}
          />
          <Custom.TextField
            label={t.label.theme}
            placeholder={t.placeholder.theme}
            fullWidth
            value={data.potluck.theme}
            onChange={(e) => updateData("potluck.theme", e.target.value)}
          />
        </Stack>
      </Box>

      <Box mt={theme.spacing.md}>
        <Stack spacing={theme.spacing.xs}>
          <Custom.Typography size={theme.font.xs} weight={theme.font.bold}>
            {t.component.workflow.potluck.create_menu}
          </Custom.Typography>
          <Custom.Typography
            size={theme.font.xs}
            color={theme.color.font.accent}
          >
            {t.component.workflow.potluck.add_category}
          </Custom.Typography>
        </Stack>
      </Box>

      <Box mt={theme.spacing.md}>
        <Field.Menu.Create
          menu={data.potluck.menu}
          onUpdate={(menu: IMenu[]) => updateData("potluck.menu", menu)}
        />
      </Box>
    </>
  );
});

export default createStep<Workflow.Utils.PotluckType>(StepDetails);
